import type { ProductSearchByImageMenuFeatureOptions } from '../../../api/models/FeatureOptions';
import type { ProductSearchByImageMenuFeatureItem } from '../../../models/features/menu/ProductSearchByImageMenuFeatureItem';
import type { AppDispatch, RootState } from '../../../store/store';
import { apiClient } from '../../ApiClient';
import { dispatchEvent } from '../../EventService';
import { getNewFeatureUuid } from '../../FeatureService';
import type { FeatureHandler } from '../FeatureHandler';

export const productSearchByImageMenuFeatureHandler = {
    startFeatureItem(
        dispatch: AppDispatch,
        state: RootState,
        featureOptions: ProductSearchByImageMenuFeatureOptions
    ): Promise<void> {
        dispatch.uiState.setMode('menu');
        dispatch.featureState.setMainFeatureItem(null);
        dispatch.featureState.setSidebarFeatureItem(null);
        dispatch.featureState.setMenuFeatureItem({
            featureUuid: getNewFeatureUuid('product-search-by-image-menu'),
            featureType: 'product-search-by-image-menu',
            searchTypes: featureOptions.searchTypes,
            imageLoadingStatus: 'idle'
        });
        return Promise.resolve();
    },
    async uploadImage(
        dispatch: AppDispatch,
        state: RootState,
        options: { imageBase64: string }
    ) {
        const menuFeatureItem = state.featureState.menuFeatureItem;
        if (menuFeatureItem?.featureType !== 'product-search-by-image-menu') {
            return;
        }
        const newMenuFeatureItem: ProductSearchByImageMenuFeatureItem = {
            ...menuFeatureItem,
            imageLoadingStatus: 'loading',
            imageBase64: options.imageBase64
        };
        dispatch.featureState.setMenuFeatureItem(newMenuFeatureItem);
        try {
            const uploadImageResult = await apiClient.assistant.uploadImage({
                body: { base64: options.imageBase64 }
            });
            const { id, url } = uploadImageResult.jsonResult;
            dispatch.featureState.setMenuFeatureItem({
                ...newMenuFeatureItem,
                imageLoadingStatus: 'idle',
                imageUrl: url,
                imageId: id
            });
            dispatchEvent({
                type: 'bri.upload_image',
                isInteraction: true,
                fileUrl: url
            });
        } catch {
            dispatch.featureState.setMenuFeatureItem({
                ...newMenuFeatureItem,
                imageLoadingStatus: 'error'
            });
        }
    }
} as const satisfies FeatureHandler<ProductSearchByImageMenuFeatureItem>;
